import { render } from "./StatistiquesSignalements.vue?vue&type=template&id=207a7fa2&scoped=true&ts=true"
import script from "./StatistiquesSignalements.vue?vue&type=script&lang=ts"
export * from "./StatistiquesSignalements.vue?vue&type=script&lang=ts"

import "./StatistiquesSignalements.vue?vue&type=style&index=0&id=207a7fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207a7fa2"]])

export default __exports__